import { makeStyles } from "@material-ui/styles"
import { EDITOR_TABLE_PADDING, MAX_MEDIA_WIDTH } from "@styles/themes";

const useStyle = makeStyles(( theme ) => ({
  
  root: {
    position: "absolute",
    zIndex: 15,
    bottom: 0,
    left: 0,
    backgroundColor: theme.props.background,
    maxWidth: "calc(100vw - 96px)",
    margin: "0 48px",
    padding: `24px ${ EDITOR_TABLE_PADDING.LARGE }px`,
    [`@media (max-width: ${MAX_MEDIA_WIDTH}px)`]: {
      padding: "24px 0",
    },
  }
}));

export default useStyle;